<template>
    <div class="header-content">
        <div class="header-title">商河县乡村振兴数字三农服务平台</div>
        <div class="header-menu">
            <a-menu v-model:selectedKeys="refCurrent" mode="horizontal" @click="handleClick">
                <a-menu-item key="home">首页</a-menu-item>
                <a-menu-item key="zx">本地农情</a-menu-item>
<!--                <a-menu-item key="sn">走进三农</a-menu-item>-->
<!--                <a-menu-item key="data">产业数据</a-menu-item>-->
                <a-sub-menu>
                    <template #title>产业数据</template>
                    <a-menu-item key="data_0">产业云图</a-menu-item>
                    <a-menu-item key="data_1">数据资源</a-menu-item>
                    <a-menu-item key="data_2">市场分析</a-menu-item>
                    <a-menu-item key="data_3">农业基地</a-menu-item>
                </a-sub-menu>
<!--                <a-menu-item key="zw">网上政务</a-menu-item>-->
                <a-menu-item key="fw">供需大厅</a-menu-item>
                <a-menu-item key="zt">主体名录库</a-menu-item>
<!--                <a-menu-item key="admin">后台</a-menu-item>-->
                <a-menu-item key="Visualization">可视化</a-menu-item>
            </a-menu>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref, onMounted } from 'vue'
import router from "@/router"
export default defineComponent({
    name: 'PortalHeader',
    props: {
        current: Array
    },
    setup(props) {
        const refCurrent = ref(['home'])
        const menuPath = {
            home: 'Home',
            sn: 'SanNong',
            zx: 'Policy',
            zw: 'Business',
            fw: 'Service',
            zt: 'MingLu',
            data: 'otherData'
        }
        onMounted(() => {
            refCurrent.value = props.current
        })
        return {
            refCurrent,
            menuPath
        }
    },
    methods: {
        handleClick(e) {
            switch (e.key) {
                case 'home':
                    if (this.refCurrent[0] === 'home') {
                        location.reload()
                    } else {
                        router.push({
                            path: '/'
                        })
                    }
                    break
                case 'admin':
                    window.open('http://shxczx.innomesh.cn:12003/#/login')
                    break
                case 'Visualization':
                    router.push({ name: '/Visualization'})
                    break
                case 'data_0':
                    router.push({path: '/portal/otherData',  query: {params: 'http://shanghe.agdata.cn/front_pages/cloud_map_list', height: 1216}})
                    break
                case 'data_1':
                    router.push({path: '/portal/otherData',  query: {params: 'http://shanghe.agdata.cn/front_pages/data_source', height: 2832}})
                    break
                case 'data_2':
                    router.push({path: '/portal/otherData',  query: {params: 'http://shanghe.agdata.cn/front_pages/market_analytical', height: 2325}})
                    break
                case 'data_3':
                    router.push({path: '/portal/otherData',  query: {params: 'http://shanghe.agdata.cn/front_pages/agriculture_matrix', height: 1982}})
                    break
                default:
                    router.push({
                        path: '/portal/' + this.menuPath[e.key]
                    })
                    break
            }
        },
    }
})
</script>
<style scoped lang="stylus">
    .header-content {
        position absolute
        left 0
        top 0
        width 100%
        .header-title {
            width 100%
            padding 20px 0 15px 30px
            font-size 28px
            color #F9CB33
            position relative
        }
        .header-menu {
            text-align right
            padding-right 80px
        }
        .header-menu >>> .ant-menu {
            background-color unset
            color #FFF
        }
        .header-menu >>> .ant-menu-item:hover {
            color #eecf5b
            border-bottom none
        }
        .header-menu >>> .ant-menu-horizontal {
            border-bottom-color rgba(0,0,0,0)
        }
        .header-menu >>> .ant-menu-horizontal {
            font-size 28px
        }
        .header-menu >>> .ant-menu-horizontal > .ant-menu-item-selected, .ant-menu-horizontal > .ant-menu-submenu-selected {
            color #F9CB33
            border-bottom none
        }
        .header-menu >>> .ant-menu-submenu-title:hover {
            color #F9CB33
        }
    }
</style>
